import React, { useState, memo } from "react";
import clsx from "clsx";
import PropTypes from "prop-types";
import {
  Card,
  CardActionArea,
  CardContent,
  Grid,
  IconButton,
  Typography,
  TextField,
  Link,
  Tooltip,
} from "@mui/material";

import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import OpenInBrowserIcon from "@mui/icons-material/OpenInBrowser";

import InnerImageZoom from "react-inner-image-zoom";

import fallbackImage from "../../../assets/images/noimage.png";
import "./Items.css";
import "react-inner-image-zoom/lib/styles.min.css";
import { useDispatch, useSelector } from "react-redux";
import {
  add_product_action,
  remove_product_action,
  set_amount_product_action,
} from "../../../redux/actions/cart";
import SwapAdd from "../../Dialogs/SwapAdd/SwapAdd";
import LowStock from "../../Dialogs/LowStock/LowStock";
import AssignOrderlist from "../../Dialogs/AssignOrderlist/AssignOrderlist";

// type: 1 = ???, type: 2 = storeAddons???, type: 3 = item codes
// todo: check on all implementations
const Items = (props) => {
  const {
    type,
    data,
    cartInfo,
    setSelectedItem,
    setOpenItemDialog,
    storeAddons,
    hidePricing,
  } = props;

  const path = props?.location?.pathname || window?.location?.pathname;

  const customerStore = useSelector((state) => state.customer);
  const currentUserStore = useSelector((state) => state.current_user);

  const [action, setAction] = useState("");
  const [cQty, setCQty] = useState(0);
  const [unitType, setUnitType] = useState("");
  const [displayLowStock, setDisplayLowStock] = useState(false);
  const [displaySubs, setDisplaySubs] = useState(false);
  const [displayLowStockClosePerm, setDisplayLowStockClosePerm] =
    useState(false);

  const dispatch = useDispatch();

  const add = () => {
    dispatch(add_product_action(data, customerStore, true));
  };

  const substract = () => {
    if (cartInfo && cartInfo.unit_in_cart > 0) {
      dispatch(remove_product_action(data, customerStore, true));
    }
  };

  const addCase = () => {
    dispatch(add_product_action(data, customerStore, false));
  };

  const substractCase = () => {
    if (cartInfo && cartInfo.case_in_cart > 0) {
      dispatch(remove_product_action(data, customerStore, false));
    }
  };

  const handleAmountChange = (e) => {
    const { name, value } = e.target;

    const amount = value === "" ? 0 : value;

    dispatch(
      set_amount_product_action(
        data,
        customerStore,
        amount,
        name === "unit_in_cart",
      ),
    );
  };

  const handleOpenItemDialog = () => {
    setSelectedItem(data);
    setOpenItemDialog(true);
  };

  const onMediaFallback = (e) => (e.target.src = fallbackImage);

  const handleLowStock = (actionFired, unitType = "", currentQty) => {
    setAction(actionFired);
    setCQty(currentQty);
    setUnitType(unitType);
    setDisplayLowStock(true);
  };

  const resetLowStock = () => {
    setAction("");
    setCQty(0);
    setUnitType("");
    setDisplayLowStock(false);
    setDisplayLowStockClosePerm(true);
  };

  const handleDisplaySubs = () => {
    setDisplayLowStock(false);
    setDisplaySubs(true);
  };

  const handleCloseSubs = () => setDisplaySubs(false);

  return (
    <>
      <LowStock
        data={data}
        action={action}
        unitType={unitType}
        cQty={cQty}
        display={displayLowStock}
        add={add}
        addCase={addCase}
        substract={substract}
        substractCase={substractCase}
        handleAmountChange={handleAmountChange}
        resetLowStock={resetLowStock}
        handleDisplaySubs={handleDisplaySubs}
      />
      <Card
        sx={{
          display: "flex",
          flexDirection: "column",
          maxWidth: 345,
          height: "100%",
        }}
        className={clsx(props.className, {
          iInactive: data.active === false,
        })}
      >
        <CardActionArea onClick={handleOpenItemDialog}>
          {/* <CardMedia
            component="img"
            loading="lazy"
            height="140"
            image={data.url || fallbackImage}
            alt={data.name || ""}
            onError={onMediaFallback}
            sx={{ objectFit: "contain" }}
          /> */}
          <div style={{ textAlign: "center" }}>
            <InnerImageZoom
              src={data.url || fallbackImage}
              loading="lazy"
              alt={data.name || ""}
              onError={onMediaFallback}
              zoomType="hover"
              hasSpacer={true}
              hideHint={true}
            />
          </div>
        </CardActionArea>
        <CardContent
          style={{ height: "100%", display: "flex", flexDirection: "column" }}
        >
          <Grid container alignItems="center">
            {type === 3 ? (
              <>
                <Grid item xs={12}>
                  <span className="typographyDescription">
                    {data.item_code ? data.item_code : ""}
                  </span>
                  {currentUserStore && currentUserStore.role_id < 12 && (
                    <>
                      <Link
                        href={`/itemcodes/${data.item_code}`}
                        target="_blank"
                      >
                        <Tooltip title="Edit item code">
                          <IconButton
                            aria-label="edit item code"
                            color="primary"
                          >
                            <OpenInBrowserIcon />
                          </IconButton>
                        </Tooltip>
                      </Link>
                    </>
                  )}
                </Grid>
                <Grid item xs={12}>
                  <span className="typographyCode">{data.name}</span>
                </Grid>
              </>
            ) : (
              <>
                <Grid item xs={12}>
                  <span className="typographyDescription">{data.name}</span>
                </Grid>
                <Grid item xs={12}>
                  <span className="typographyCode">
                    {data.item_code ? data.item_code.item_code : ""}
                    {currentUserStore && currentUserStore.role_id < 12 && (
                      <Link href={`/product/${data.upc}`} target="_blank">
                        <Tooltip title="Edit product">
                          <IconButton aria-label="edit product">
                            <OpenInNewIcon />
                          </IconButton>
                        </Tooltip>
                      </Link>
                    )}
                    {type === 1 &&
                      currentUserStore &&
                      currentUserStore.role_id < 12 && (
                        <>
                          <Link
                            href={`/itemcodes/${data?.item_code?.item_code}`}
                            target="_blank"
                          >
                            <Tooltip title="Edit item code">
                              <IconButton
                                aria-label="edit item code"
                                color="primary"
                              >
                                <OpenInBrowserIcon />
                              </IconButton>
                            </Tooltip>
                          </Link>
                        </>
                      )}
                  </span>
                </Grid>
              </>
            )}
            {data.display_unit_price > 0 && !hidePricing ? (
              <>
                <Grid
                  item
                  xs={type === 1 && storeAddons ? 6 : 12}
                  style={{
                    background:
                      data.default_unit_type === "u"
                        ? "lightyellow"
                        : "inherit",
                  }}
                >
                  <span className="typographyPriceUnit">
                    ${data.display_unit_price}
                    <span style={{ fontWeight: 900 }}> UNIT</span>
                  </span>

                  {data.display_unit_price_per_lb ? (
                    <>
                      <br />
                      <span className="typographyPricePerLbUnit">
                        Price per lb:
                        {data.display_unit_price_per_lb
                          ? " $" + data.display_unit_price_per_lb
                          : " N/A"}
                      </span>
                    </>
                  ) : (
                    <></>
                  )}
                </Grid>
                {type === 1 && storeAddons && (
                  <>
                    <Grid
                      item
                      xs={2}
                      style={{
                        background:
                          data.default_unit_type === "u"
                            ? "lightyellow"
                            : "inherit",
                      }}
                    >
                      <IconButton
                        onClick={() =>
                          (data.stock_level_indicator === "low stock" ||
                            data.combined_stock_level === null) &&
                          !displayLowStockClosePerm
                            ? handleLowStock("substract")
                            : substract()
                        }
                        style={{ padding: 0 }}
                      >
                        <RemoveIcon color="error" />
                      </IconButton>
                    </Grid>
                    <Grid
                      item
                      xs={2}
                      style={{
                        background:
                          data.default_unit_type === "u"
                            ? "lightyellow"
                            : "inherit",
                      }}
                    >
                      <TextField
                        fullWidth
                        size="small"
                        variant="standard"
                        name="unit_in_cart"
                        value={cartInfo ? cartInfo.unit_in_cart : 0}
                        onChange={(e) =>
                          (data.stock_level_indicator === "low stock" ||
                            data.combined_stock_level === null) &&
                          !displayLowStockClosePerm
                            ? handleLowStock(
                                "amount",
                                "unit_in_cart",
                                cartInfo ? cartInfo.unit_in_cart : 0,
                              )
                            : handleAmountChange(e)
                        }
                        inputProps={{ style: { textAlign: "center" } }}
                      />
                    </Grid>
                    <Grid
                      item
                      xs={2}
                      style={{
                        background:
                          data.default_unit_type === "u"
                            ? "lightyellow"
                            : "inherit",
                      }}
                    >
                      <IconButton
                        onClick={() =>
                          (data.stock_level_indicator === "low stock" ||
                            data.combined_stock_level === null) &&
                          !displayLowStockClosePerm
                            ? handleLowStock("add")
                            : add()
                        }
                        style={{ padding: 0 }}
                      >
                        <AddIcon color="success" />
                      </IconButton>
                    </Grid>
                  </>
                )}
              </>
            ) : (
              <></>
            )}
            {data.display_case_price > 0 && !hidePricing ? (
              <>
                <Grid
                  item
                  xs={type === 1 && storeAddons ? 6 : 12}
                  style={{
                    background:
                      data.default_unit_type === "c"
                        ? "lightyellow"
                        : "inherit",
                  }}
                >
                  <span className="typographyPriceCase">
                    ${data.display_case_price} ({data.units_per_case}){" "}
                    <span style={{ fontWeight: 900 }}> CASE</span>
                  </span>
                  {data.display_case_price_per_lb ? (
                    <>
                      <br />
                      <span className="typographyPricePerLbCase">
                        Price per lb:
                        {data.display_case_price_per_lb
                          ? " $" + data.display_case_price_per_lb
                          : " N/A"}
                      </span>
                    </>
                  ) : (
                    <></>
                  )}
                </Grid>
                {type === 1 && storeAddons && (
                  <>
                    <Grid
                      item
                      xs={2}
                      style={{
                        background:
                          data.default_unit_type === "c"
                            ? "lightyellow"
                            : "inherit",
                      }}
                    >
                      <IconButton
                        onClick={() =>
                          (data.stock_level_indicator === "low stock" ||
                            data.combined_stock_level === null) &&
                          !displayLowStockClosePerm
                            ? handleLowStock("substractCase")
                            : substractCase()
                        }
                        style={{ padding: 0 }}
                      >
                        <RemoveIcon color="error" />
                      </IconButton>
                    </Grid>
                    <Grid
                      item
                      xs={2}
                      style={{
                        background:
                          data.default_unit_type === "c"
                            ? "lightyellow"
                            : "inherit",
                      }}
                    >
                      <TextField
                        fullWidth
                        size="small"
                        variant="standard"
                        name="case_in_cart"
                        value={cartInfo ? cartInfo.case_in_cart : 0}
                        onChange={(e) =>
                          (data.stock_level_indicator === "low stock" ||
                            data.combined_stock_level === null) &&
                          !displayLowStockClosePerm
                            ? handleLowStock(
                                "amount",
                                "case_in_cart",
                                cartInfo ? cartInfo.case_in_cart : 0,
                              )
                            : handleAmountChange(e)
                        }
                        inputProps={{ style: { textAlign: "center" } }}
                      />
                    </Grid>
                    <Grid
                      item
                      xs={2}
                      style={{
                        background:
                          data.default_unit_type === "c"
                            ? "lightyellow"
                            : "inherit",
                      }}
                    >
                      <IconButton
                        onClick={() =>
                          (data.stock_level_indicator === "low stock" ||
                            data.combined_stock_level === null) &&
                          !displayLowStockClosePerm
                            ? handleLowStock("addCase")
                            : addCase()
                        }
                        style={{ padding: 0 }}
                      >
                        <AddIcon color="success" />
                      </IconButton>
                    </Grid>
                  </>
                )}
              </>
            ) : (
              <></>
            )}
            {[1, 2].includes(type) &&
              currentUserStore &&
              currentUserStore.role_id !== 32 && (
                <Grid item xs={12}>
                  <span className="typographyInventory">
                    {` Combined Stock: `}
                    <b>{`${data.combined_stock_level || "N/A"}`}</b>
                  </span>
                </Grid>
              )}
            {type === 1 &&
              storeAddons &&
              currentUserStore &&
              currentUserStore.role_id === 32 &&
              data.stock_level_indicator !== "" &&
              data.stock_level_indicator !== null && (
                <Grid item xs={12}>
                  <Typography align="left" className="typographyInventory">
                    {` Stock: `}
                    <b>{`${data.stock_level_indicator || "N/A"}`}</b>
                  </Typography>
                </Grid>
              )}
          </Grid>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 8,
              marginTop: "auto",
            }}
          >
            {type === 1 && storeAddons && currentUserStore.role_id < 30 ? (
              <div>
                <SwapAdd
                  data={data}
                  display={displaySubs}
                  setDisplaySubs={setDisplaySubs}
                  handleCloseSubs={handleCloseSubs}
                />
              </div>
            ) : (
              <></>
            )}
            {[1, 2].includes(type) &&
              !path?.includes("order") &&
              !path?.includes("demo") && (
                <div>
                  <AssignOrderlist data={data} />
                </div>
              )}
          </div>
        </CardContent>
      </Card>
    </>
  );
};

Items.propTypes = {
  type: PropTypes.number.isRequired,
};

export default memo(Items, (prev, next) => {
  return prev.cartInfo || next.cartInfo || prev.reloadable || next.reloadable
    ? false
    : true;
});
